import React, { useState, type FC } from 'react';
import styled from 'styled-components';
import { Grid, Paragraph } from '../UIKit/system';
import LazyImage from '../lazy-image';
import Title from '../title';
import { getFluidGatsbyImage } from '../../utils/gatsby-storyblok-image-fixed';
import Button from '../button';
import RichTextField from '../rich-text-field';
import File from '../../images/svg/file.svg';
import DownloadPopup from '../resource-centre/download-popup';

interface InfoImageCardProps {
  image?: Record<string, any>;
  title: string;

  /**
   * Takes a string or rich text object.
   */
  text: string | Record<string, any>;
  link: string;
  linkText: string;
  linkPrimary?: boolean;
  isDownload?: boolean;
  gated?: boolean;
}

export const IconInfoCard: FC<InfoImageCardProps> = (props) => {
  const { image, title, text, link, linkText, linkPrimary, isDownload, gated } =
    props;

  return (
    <StyledContainer>
      <Grid width={42} gridArea="image" alignItems="center">
        {image ? (
          <LazyImage fluid={getFluidGatsbyImage(image)} />
        ) : (
          <StyledFile />
        )}
      </Grid>
      <Grid gridArea="info">
        <Title as="h3" fontSizeExtraSmall>
          {title}
        </Title>
        <StyledText>
          {typeof text === 'string' && text}
          {typeof text === 'object' && <RichTextField data={text} />}
        </StyledText>
      </Grid>
      {gated ? (
        <GatedDownload
          link={link}
          title={linkText}
          transparentInverted={!linkPrimary}
          primary={linkPrimary}
        />
      ) : (
        <Button
          to={link}
          transparentInverted={!linkPrimary}
          primary={linkPrimary}
          gridArea="button"
          target={isDownload ? '_blank' : undefined}
        >
          {linkText}
        </Button>
      )}
    </StyledContainer>
  );
};

const StyledContainer = styled(Grid).attrs(() => ({
  gridTemplateAreas: [
    `"image info info"
     "empty button button";
    `,
    `"image info button";
    `
  ],
  gridTemplateColumns: 'auto 1fr auto',
  gridGap: 26,
  backgroundColor: 'lightGrey',
  px: 32,
  py: 26,
  borderRadius: 'var(--Radius-Radius-3, 16px)'
}))``;

const StyledFile = styled(File)`
  width: 42px;
  margin-top: 10px;
`;

const StyledText = styled(Paragraph).attrs(() => ({
  color: 'grey',
  fontSizeExtraSmall: true,
  mt: 6
}))`
  ul {
    li {
      margin-bottom: 5px;
    }
  }
`;

const GatedDownload: FC<{
  link: string;
  title: string;
  primary?: boolean;
  transparentInverted?: boolean;
}> = (props) => {
  const { link, title, primary, transparentInverted } = props;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        to="#"
        onClick={(event) => {
          event.preventDefault();
          setIsOpen(true);
        }}
        primary={primary}
        transparentInverted={transparentInverted}
        gridArea="button"
      >
        {title}
      </Button>
      {isOpen && (
        <DownloadPopup
          filePath={link}
          handlePopupClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};
